import { Navigate, useParams } from "react-router-dom";

// Reorder feature removed. Any existing /reorder/:orderId link now redirects
// to the order's detail page without adding anything to the cart.
export default function Reorder() {
  const { orderId } = useParams();
  if (!orderId) return <Navigate to="/orders" replace />;
  return <Navigate to={`/orders/${orderId}`} replace />;
}
